import { Component } from '@angular/core';
import { fadeIn, fadeOut } from './carousel/carousel.animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'SRD-Softtech';

  public slides = [
    {
      src: 'assets/images/invoice_billing_feature.png',
    },
    {
      src:
        'assets/images/Billing-Invoicing-Software-for-Small-Businesses-in-India.png',
    },
    { src: 'assets/images/billing-image.png' },
    { src: 'assets/images/writing-editing.jpg' },
    { src: 'assets/images/web-design-page.png' },
  ];
}
